// Simple provider logo resolver. Uses static SVGs with a generic placeholder fallback.

import ai21Logo from '../assets/providers/ai21.svg';
import amazonLogo from '../assets/providers/amazon.svg';
import anthropicLogo from '../assets/providers/anthropic.svg';
import cohereLogo from '../assets/providers/cohere.svg';
import deepseekLogo from '../assets/providers/deepseek.svg';
import metaLogo from '../assets/providers/meta.svg';
import mistralLogo from '../assets/providers/mistral.svg';
import openaiLogo from '../assets/providers/openai.svg';
import placeholderLogo from '../assets/providers/placeholder.svg';
import twelveLabsLogo from '../assets/providers/twelve-labs.png';

const LOGO_MAP: Record<string, string | undefined> = {
  'ai21 labs': ai21Logo,
  anthropic: anthropicLogo,
  cohere: cohereLogo,
  deepseek: deepseekLogo,
  meta: metaLogo,
  'mistral ai': mistralLogo,
  amazon: amazonLogo,
  twelvelabs: twelveLabsLogo
};

export function getProviderLogo(providerName?: string): string {
  if (!providerName) return placeholderLogo;
  const key = providerName
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9 ]/g, '') // remove punctuation
    .replace(/\s+/g, ' ') // collapse spaces
    .trim()
    .replace(/\s/g, ''); // remove spaces for keys like meta ai -> metaai
  const resolved = LOGO_MAP[key] || LOGO_MAP[providerName.trim().toLowerCase()];
  return resolved || placeholderLogo;
}
